<div class="favorite-bar">
  <label class="bar-label">Map Favorite</label>
  <div class="form-group favorite-select">
    <ng-select [items]="mapFavoritesNamesToDisplay"
               bindLabel="name"
               (change)="favoriteSelectionChanged()"
               placeholder="Select Favorite"
               [(ngModel)]="selectedMapFavorite"
               (focus)="updateMapFavoritesList(globalSwitch)"
               groupBy="toGroupBy">
    </ng-select>
  </div>
  <button type="button" class="btn btn-success" (click)="saveMapFavorite(template)" [disabled]="!canSave">Save</button>
  <button type="button" class="btn btn-danger" (click)="onDeleteMapFavoriteConfirm()" [disabled]="!canDeleteFavorite()">Delete</button>
  <label *ngIf="selectedMapFavorite != undefined" class="bar-label">id={{ selectedMapFavorite.id }}</label>
  <span *ngIf="!isUpdate()" class="bar-hint">Save as a favorite to add labels</span>
</div>


<ng-template #template>
  <div>
    <div style="background-color: #548235; height: 7px;"></div>
    <div class="modal-header" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Map Favorite</h5>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div class="col-md-12">
          <form (ngSubmit)="addOrUpdateMapFavorite()" #favoriteNameEditor="ngForm">
            <div class="form-group" style="margin-bottom: 20px;">
              <label for="mapFavoriteName">Favorite Name for Map Settings*</label>
              <input type="text" id="mapFavoriteName" name="favoriteName" class="form-control" [(ngModel)]="favoriteName" required />
            </div>

            <div class="form-group" style="margin-bottom: 20px;">
              <label for="MapFavorite">Access Group*</label>
              <ngx-select-dropdown [(ngModel)]="selectedUserGroup" [config]="userGroupconfig"
                [options]="associatedUserGroups" name="MapFavorite"></ngx-select-dropdown>
            </div>

            <button *ngIf="!isUpdate()" type="submit" class="btn btn-success col-xs-5 pull-right">Create</button>
            <button *ngIf="isUpdate()" type="submit" class="btn btn-success col-xs-5 pull-right">Update</button>
            <button type="button" class="btn btn-basic col-xs-5 pull-right" (click)="onFavoriteCancelButton()">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<p-confirmDialog key="mapFavoriteBarDelete" #confirmDelete>
  <ng-template #footer>
    <button type="button" class="btn btn-success" (click)="confirmDelete.onAccept()">Yes</button>
    <button type="button" class="btn btn-basic" (click)="confirmDelete.onReject()">No</button>
  </ng-template>
</p-confirmDialog>
